import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../colors';

export const HandleReservationPageStyled = {
  Container: styled(Grid)<any>`
    width: 100%;
    background: ${Colors.PrimaryBackground};
    padding-left: 16px;
    padding-right: 16px;
  `,
  ContainerSearch: styled(Grid)<any>`
    display: flex;
    align-items: center;
    border-bottom: 2px solid ${Colors.UnderlinedGrey};
    background-color: ${Colors.LightGrey};
    padding: 0 30px 0 30px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  `,
  ContainerEditSearch: styled(Grid)<any>`
    width: 40%;
  `,
  ContainerIconSearch: styled(Grid)<any>`
  `,
  BoxReservation: styled(Grid)<any>`
    margin-top: 28px;
    margin-bottom: 28px;
    width: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    background-color: ${Colors.White};
  `,
  ReservationDetails: styled(Grid)<any>`
    display: flex;
    flex-direction: column;
    padding: 15px 30px 30px 30px;
  `,
  ContainerReservationValue: styled(Grid)<any>`
  `,
  ReservationValue: styled.p<any>`
    font-family: EncodeSans-Regular;
    color: ${(props: any) => props.color ? props.color: Colors.Primary}
    
  `,
  ReservationLabel: styled.span<any>`
    font-family: EncodeSans-Regular;
    color: ${Colors.Black}
  `,
  ContainerDetailReservationRow: styled(Grid)<any>`
    display: flex;
    align-items: center;
    
  `,
  ContainerStatus: styled(Grid)<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  ContainerButtonConfirm: styled(Grid)<any>`
  `,
  NotesContainer:  styled.div<any>`
  `,
  DetailsContainer: styled(Grid)<any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${Colors.White};
    border-radius: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
  `,
  FieldDetailContainer: styled(Grid)<any>`
    display: flex;
    flex: 1;
    padding: 10px;
    align-items: center;
  `,
  FieldDetailLabel: styled.p`
    font-size: 11px;
    padding: 7px 10px 7px 0px;
    font-family: EncodeSans-Bold;
    letter-spacing: 1px;
  `,
  FieldDetailValue: styled.p`
    font-size: 14px;
    font-family: EncodeSans-Regular;
    letter-spacing: 1px;
    word-wrap: break-word;
  `,
};
